import { Flex, H1, P } from "orcs-design-system";
import React from "react";

import icons from "src/config/icons";
import EmptyAppNav from "src/components/Nav/EmptyAppNav";
import { ErrorBox, ErrorContainer, ErrorIcon } from "./ErrorPageStyles";
import ErrorFooter from "./ErrorFooter";
import { copywriting } from "./ErrorPage.config";

const SafeErrorMessage = () => {
  return (
    <>
      <EmptyAppNav useAppLinkRoute={false} />
      <ErrorContainer allowSpaceForHeader>
        <ErrorBox>
          <Flex
            flexDirection="row"
            justifyContent="start"
            alignItems="flex-start"
          >
            <ErrorIcon icon={icons.exclamationTriangle} />
            <Flex flexDirection="column" gap="r">
              <H1>{copywriting.safeErrorHeading}</H1>
              <P>{copywriting.safeErrorDetail}</P>
              <ErrorFooter />
            </Flex>
          </Flex>
        </ErrorBox>
      </ErrorContainer>
    </>
  );
};

export default SafeErrorMessage;
